import { render, staticRenderFns } from "./EditarProfissional.vue?vue&type=template&id=411255a0&scoped=true&"
import script from "./EditarProfissional.vue?vue&type=script&lang=js&"
export * from "./EditarProfissional.vue?vue&type=script&lang=js&"
import style0 from "./EditarProfissional.vue?vue&type=style&index=0&id=411255a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411255a0",
  null
  
)

export default component.exports